import { JSX } from 'preact'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { useFormContext } from '../Form/useFormContext'

export function HiddenInput({ name, ...props }: TBlockProps<BlockType.Hidden>): JSX.Element {
  const { getValue } = useFormContext()
  const value = getValue(name)

  const className = classnames(props.className, 'input-hidden', { filled: !!value })

  return <input className={className} type="hidden" name={name} value={value} />
}
